import { render, staticRenderFns } from "./leifeng_health_suggestion.vue?vue&type=template&id=3b314ea8&scoped=true&"
import script from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
export * from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
import style0 from "./leifeng_health_suggestion.vue?vue&type=style&index=0&id=3b314ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b314ea8",
  null
  
)

export default component.exports